<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Tulostimet: C2326, C3224, C3326, C3426, CS331, CS431, CS439">
     Tulostimet: C2326, C3224, C3326, C3426, CS331, CS431, CS439
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_fi" title="Turvaohjeita">
     Turvaohjeita
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Merkint&auml;tavat">
      Merkint&auml;tavat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Tuotelausunnot">
      Tuotelausunnot
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_fi" title="Tietoja tulostimesta">
     Tietoja tulostimesta
    </a>
   </p>
   <div id="divd0e173">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_fi" title="Tulostintietojen etsiminen">
      Tulostintietojen etsiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_fi" title="Tulostimien sarjanumeron etsiminen">
      Tulostimien sarjanumeron etsiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_fi" title="Tulostinkokoonpanot">
      Tulostinkokoonpanot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_fi" title="Ohjauspaneelin k&auml;ytt&auml;minen">
      Ohjauspaneelin k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_fi" title="Aloitusn&auml;yt&ouml;n mukauttaminen">
      Aloitusn&auml;yt&ouml;n mukauttaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_fi" title="Merkkivalon tilan merkitys">
      Merkkivalon tilan merkitys
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e627" title="Paperin valinta">
      Paperin valinta
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_fi" title="K&auml;ytt&ouml;&ouml;notto, asennus ja kokoonpano">
     K&auml;ytt&ouml;&ouml;notto, asennus ja kokoonpano
    </a>
   </p>
   <div id="divd0e1351">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_fi" title="Tulostimen paikan valitseminen">
      Tulostimen paikan valitseminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_fi" title="Kaapelien liitt&auml;minen">
      Kaapelien liitt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-trays-topic.html#installing-optional-trays_fi" title="Lis&auml;lokeroiden asentaminen">
      Lis&auml;lokeroiden asentaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#d0e1549" title="Aloitusn&auml;yt&ouml;n sovellusten asentaminen ja k&auml;ytt&auml;minen">
      Aloitusn&auml;yt&ouml;n sovellusten asentaminen ja k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e1676" title="Paperin ja erikoismateriaalin lis&auml;&auml;minen">
      Paperin ja erikoismateriaalin lis&auml;&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e1851" title="Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja p&auml;ivitt&auml;minen">
      Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja p&auml;ivitt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e2110" title="Verkkoyhteydet">
      Verkkoyhteydet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_fi" title="Valikkoasetussivun tulostus">
      Valikkoasetussivun tulostus
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_fi" title="Tulostimen suojaaminen">
     Tulostimen suojaaminen
    </a>
   </p>
   <div id="divd0e2555">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_fi" title="Tulostinmuistin tyhjent&auml;minen">
      Tulostinmuistin tyhjent&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_fi" title="Oletusasetusten palautus">
      Oletusasetusten palautus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_fi" title="Haihtuvuusjulistus">
      Haihtuvuusjulistus
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_fi" title="Tulostaminen">
     Tulostaminen
    </a>
   </p>
   <div id="divd0e2677">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_fi" title="Tulostaminen tietokoneella">
      Tulostaminen tietokoneella
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2703" title="Tulostaminen mobiililaitteesta">
      Tulostaminen mobiililaitteesta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_fi" title="Luottamuksellisten t&ouml;iden m&auml;&auml;ritt&auml;minen">
      Luottamuksellisten t&ouml;iden m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_fi" title="Luottamuksellisten ja muiden pidossa olevien t&ouml;iden tulostaminen">
      Luottamuksellisten ja muiden pidossa olevien t&ouml;iden tulostaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_fi" title="Tulostaminen Cloud Connector -profiilista">
      Tulostaminen Cloud Connector -profiilista
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_fi" title="Fonttimalliluettelon tulostaminen">
      Fonttimalliluettelon tulostaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_fi" title="Erotinsivujen lis&auml;&auml;minen kopioiden v&auml;liin">
      Erotinsivujen lis&auml;&auml;minen kopioiden v&auml;liin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_fi" title="Tulostusty&ouml;n peruuttaminen">
      Tulostusty&ouml;n peruuttaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_fi" title="V&auml;riaineen tummuuden s&auml;&auml;t&auml;minen">
      V&auml;riaineen tummuuden s&auml;&auml;t&auml;minen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_fi" title="Tulostinvalikkojen k&auml;ytt&ouml;">
     Tulostinvalikkojen k&auml;ytt&ouml;
    </a>
   </p>
   <div id="divd0e3245">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_fi" title="Valikkokartta">
      Valikkokartta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3502" title="Laite">
      Laite
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e4994" title="Tulosta">
      Tulosta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e5942" title="Paperi">
      Paperi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6182" title="Verkko/portit">
      Verkko/portit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8172" title="Suojaus">
      Suojaus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_fi" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e8828" title="Raportit">
      Raportit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_fi" title="Vianm&auml;&auml;ritys">
      Vianm&auml;&auml;ritys
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_fi" title="Tulostimen yll&auml;pito">
     Tulostimen yll&auml;pito
    </a>
   </p>
   <div id="divd0e9031">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_fi" title="Tulostimen osien ja tarvikkeiden tilan tarkistaminen">
      Tulostimen osien ja tarvikkeiden tilan tarkistaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_fi" title="Tarvikeilmoitusten m&auml;&auml;ritt&auml;minen">
      Tarvikeilmoitusten m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_fi" title="S&auml;hk&ouml;postih&auml;lytysten m&auml;&auml;ritt&auml;minen">
      S&auml;hk&ouml;postih&auml;lytysten m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_fi" title="Raporttien tarkasteleminen">
      Raporttien tarkasteleminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_fi" title="Tulostimen osien ja tarvikkeiden tilaaminen">
      Tulostimen osien ja tarvikkeiden tilaaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-print-cartridge-topic.html#d0e9850" title="Tulostimen osien ja tarvikkeiden vaihtaminen">
      Tulostimen osien ja tarvikkeiden vaihtaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e10048" title="Tulostimen osien puhdistaminen">
      Tulostimen osien puhdistaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e10169" title="Energian ja paperin s&auml;&auml;st&auml;minen">
      Energian ja paperin s&auml;&auml;st&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_fi" title="Tulostimen siirt&auml;minen toiseen paikkaan">
      Tulostimen siirt&auml;minen toiseen paikkaan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_fi" title="Tulostimen kuljettaminen">
      Tulostimen kuljettaminen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_fi" title="Vianm&auml;&auml;ritys">
     Vianm&auml;&auml;ritys
    </a>
   </p>
   <div id="divd0e10330">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_fi" title="Tulostuslaatuongelmat">
      Tulostuslaatuongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e10430" title="Tulostusongelmat">
      Tulostusongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_fi" title="Tulostin ei vastaa">
      Tulostin ei vastaa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e12835" title="Verkkoyhteysongelmat">
      Verkkoyhteysongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e13054" title="Tarvikeongelmat">
      Tarvikeongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_fi" title="Tukosten poistaminen">
      Tukosten poistaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e13491" title="Paperinsy&ouml;tt&ouml;ongelmat">
      Paperinsy&ouml;tt&ouml;ongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e13873" title="V&auml;rinlaatuongelmat">
      V&auml;rinlaatuongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_fi" title="Yhteyden ottaminen asiakastukeen">
      Yhteyden ottaminen asiakastukeen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_fi" title="Kierr&auml;tys ja h&auml;vitt&auml;minen">
     Kierr&auml;tys ja h&auml;vitt&auml;minen
    </a>
   </p>
   <div id="divd0e14112">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_fi" title="Lexmark-tuotteiden kierr&auml;tt&auml;minen">
      Lexmark-tuotteiden kierr&auml;tt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_fi" title="Lexmark-pakkauksen kierr&auml;tt&auml;minen">
      Lexmark-pakkauksen kierr&auml;tt&auml;minen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_fi" title="Tiedotteet">
     Tiedotteet
    </a>
   </p>
   <div id="divd0e14147">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14150" title="Tuotetiedot">
      Tuotetiedot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14167" title="Painosta koskeva tiedote">
      Painosta koskeva tiedote
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_fi" title="Tavaramerkit">
      Tavaramerkit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_fi" title="K&auml;ytt&ouml;oikeustiedote">
      K&auml;ytt&ouml;oikeustiedote
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_fi" title="Emissiotaso">
      Emissiotaso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_fi" title="S&auml;hk&ouml;- ja elektroniikkaromudirektiivi (SER)">
      S&auml;hk&ouml;- ja elektroniikkaromudirektiivi (SER)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14264" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_fi" title="Laitteen h&auml;vitt&auml;minen">
      Laitteen h&auml;vitt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14298" title="Litiumioniakku">
      Litiumioniakku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_fi" title="Asetus (EU) 2023/1542">
      Asetus (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_fi" title="Staattista s&auml;hk&ouml;&auml; koskeva tiedote">
      Staattista s&auml;hk&ouml;&auml; koskeva tiedote
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_fi" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_fi" title="L&auml;mp&ouml;tilatiedot">
      L&auml;mp&ouml;tilatiedot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_fi" title="Laserilmoitus">
      Laserilmoitus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_fi" title="Virrankulutus">
      Virrankulutus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14531" title="Langattomia tuotteita koskevat s&auml;&auml;nn&ouml;kset">
      Langattomia tuotteita koskevat s&auml;&auml;nn&ouml;kset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_fi" title="Ilmoitus modulaarisista komponenteista">
      Ilmoitus modulaarisista komponenteista
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_fi" title="Altistus radiotaajuuss&auml;teilylle">
      Altistus radiotaajuuss&auml;teilylle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14557" title="Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus">
      Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_fi" title="Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus">
      Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue